import React from "react";
import { RaisedButton, Dialog, FlatButton } from "material-ui";
import { Link } from "react-router";
import moment from "moment";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketStore from "../stores/EventBucketStore";
import EventBucketActions from "../actions/EventBucketActions";
import PassStore from "../stores/PassStore";
import PassActions from "../actions/PassActions";
import BoxOfficeUtil from "../utils/BoxOfficeUtil";
import UserStore from "../stores/UserStore";

import LinkLike from "./partials/link-like.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";
import InjectedSelect from "./partials/injected-select.jsx";

import PrintPassesModal from "./partials/print-passes-modal.jsx";
import SupplementaryDataModal from "./partials/supplementary-data-modal.jsx";
import InlineNoticeLabel from "./partials/inline-notice-label.jsx";
import KeyboardPeripheralInput from "./partials/keyboard-peripheral-input.jsx";

class CheckIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      creatingOrder: null,
      currentlyPrinting: false,
      currentlyEditingSupplementaryData: false,
      selectedPassId: null
    };

    this.isNfcMode = this.isNfcMode.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onCreate = this.onCreate.bind(this);
    this.onSubmitNewPass = this.onSubmitNewPass.bind(this);
    this.onCheckinPrintNfc = this.onCheckinPrintNfc.bind(this);
    this.onCancelCheckinPrintNfc = this.onCancelCheckinPrintNfc.bind(this);
  }

  static getStores() {
    return [EventBucketStore, PassStore];
  }

  static getPropsFromStores() {
    return {
      getEventBucketById: EventBucketStore.getEventBucketById,
      getPassById: PassStore.getPassById,
      getPassesForEventBucket: PassStore.getPassesForEventBucket,
      getMembershipsForEventBucket: PassStore.getMembershipsForEventBucket,
      isFetching: PassStore.getState().isFetching,
      isEditing: PassStore.getState().isEditing
    };
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(props) {
    let bucket = this.props.getEventBucketById(props.params.eventBucketId);
  }

  getStyles() {
    return {
      header: {
        textAlign: "center",
        marginBottom: "1em"
      },
      body: {
        textAlign: "center"
      },
      intro: {
        color: "rgb(33,33,33)",
        textAlign: "center"
      },
      childen: {
        textAlign: "left",
        fontSize: "12pt"
      },
      select: {
        maxWidth: 500,
        margin: "0 auto"
      },
      passInfo: {
        maxWidth: 500,
        margin: "0 auto",
        marginTop: "1em",
        padding: "1em",
        border: "1px solid #ccc",
        display: "flex",
        alignItems: "center"
      },
      actions: {
        textAlign: "right"
      },
      stats: {
        maxWidth: 350,
        margin: "1em auto",
        padding: "1em",
        fontSize: "11pt"
      },
      statsHeader: {
        fontWeight: "bold",
        textAlign: "center",
        marginBottom: "0.75em",
        fontSize: "12pt"
      }
    };
  }

  isNfcMode() {
    let eventBucket = this.props.getEventBucketById(
      this.props.params.eventBucketId
    );
    return eventBucket && eventBucket.enable_nfc;
  }

  onSelect(selectedPassId) {
    this.context.router.replace({
      pathname: this.props.location.pathname,
      state: {
        selectedPassId: selectedPassId
      }
    });
  }

  onCreate(name) {
    this.setState({
      creatingOrder: {
        name: name.value
      }
    });
  }

  onSubmitNewPass({ email, name, pass_bucket, supplementary_data }) {
    BoxOfficeUtil.submitOrder(UserStore.getState().apiKey, {
      type: "check_in",
      event_bucket: this.props.params.eventBucketId,
      email: email || "unaffiliated@eventive.org",
      subitems: [
        {
          pass_bucket: pass_bucket,
          quantity: 1,
          names: [name],
          supplementary_datas: [supplementary_data]
        }
      ]
    })
      .then(data => {
        const pass = data.passes[0];
        PassActions.fetchOne(pass.id);
        this.setState({ creatingOrder: null }, () => {
          if (this.isNfcMode()) {
            this.onCheckinPrintNfc(pass.id);
          } else {
            this.onSelect(pass.id);
          }
        });
      })
      .catch(e => {
        window.alert(`Failed to create pass: ${e.message}`);
      });
  }

  onCheckinPrintNfc(passId) {
    PassActions.edit(passId, {
      checked_in: true
    });

    this.context.router.replace({
      pathname: this.props.location.pathname,
      state: {
        ...this.props.location.state,
        selectedPassId: passId,
        currentlyCheckinPrintNfcFlow: true
      }
    });

    this.setState({
      currentlyPrinting: true
    });
  }

  onCancelCheckinPrintNfc() {
    this.context.router.replace({
      pathname: this.props.location.pathname,
      state: {
        ...this.props.location.state,
        currentlyCheckinPrintNfcFlow: false
      }
    });
  }

  render() {
    const { eventBucketId } = this.props.params,
      {
        currentlyPrinting,
        currentlyEditingSupplementaryData,
        creatingOrder
      } = this.state,

      eventBucket = this.props.getEventBucketById(eventBucketId),
      styles = this.getStyles();

    let allPasses = [];

    if (this.props.location.pathname.includes("pass_buckets")) {
      allPasses = this.props.getPassesForEventBucket(eventBucketId);
    } else if (this.props.location.pathname.includes("memberships")) {
      allPasses = this.props.getMembershipsForEventBucket(eventBucketId)
    } else {
      allPasses = [...this.props.getPassesForEventBucket(eventBucketId), ...this.props.getMembershipsForEventBucket(eventBucketId)]
    }

    if (!eventBucket) {
      return <WorkingIndicator fullPage={true} />;
    }

    let stats = allPasses.reduce((d, p) => {
      if (!d[p.pass_bucket.id]) {
        d[p.pass_bucket.id] = {
          name: p.pass_bucket.name,
          checked_in: 0,
          total: 0
        };
      }

      d[p.pass_bucket.id].total++;
      if (p.checked_in_at) {
        d[p.pass_bucket.id].checked_in++;
      }

      return d;
    }, {});

    let currentlyCheckinPrintNfcFlow =
      this.props.location.state &&
      this.props.location.state.currentlyCheckinPrintNfcFlow;

    let selectedPassId =
      this.props.location.state && this.props.location.state.selectedPassId;
    let selectedPass = selectedPassId
      ? PassStore.getPassById(this.props.location.state.selectedPassId)
      : null;

    const isMembership = this.props.location.pathname.includes("memberships")

    return (
      <div>
        {creatingOrder ? (
          <SupplementaryDataModal
            isCreatingAtCheckIn={true}
            pass={{
              name: creatingOrder.name,
              supplementary_data: {}
            }}
            onSubmit={this.onSubmitNewPass}
            requestClose={() => this.setState({ creatingOrder: null })}
            eventBucketId={eventBucketId}
          />
        ) : null}
        {currentlyPrinting ? (
          <PrintPassesModal
            id={selectedPassId}
            eventBucket={eventBucket.id}
            requestClose={() =>
              setTimeout(() => {
                this.setState({ currentlyPrinting: false });
              }, 100)
            }
          />
        ) : null}
        {currentlyEditingSupplementaryData ? (
          <SupplementaryDataModal
            pass={selectedPass}
            requestClose={() =>
              this.setState({ currentlyEditingSupplementaryData: false })
            }
          />
        ) : null}
        {currentlyCheckinPrintNfcFlow && !currentlyPrinting ? (
          <Dialog
            title="Tap NFC tag"
            actions={[
              <FlatButton
                label="Cancel"
                primary={true}
                onClick={() => this.onCancelCheckinPrintNfc()}
              />
            ]}
            modal={true}
            openImmediately={true}
            open={true}
          >
            Tap the NFC tag now.
            <KeyboardPeripheralInput
              onChange={raw => {
                PassActions.edit(selectedPass.id, {
                  external_barcode: raw
                });
                this.onCancelCheckinPrintNfc();
              }}
            />
          </Dialog>
        ) : null}
        <h1 style={styles.header}>{eventBucket.name} {isMembership ? "Pick-Up" : "Check-In"}</h1>
        <div style={styles.body}>
          <div style={styles.childen}>
            <p style={styles.intro}>
              {isMembership ? "Confirm pick-up of memberships, print labels, & generate new memberships on the fly. " : "Check-in passholders, print labels, & generate new passes on the fly. "}
              {eventBucket.enable_nfc ? (
                <InlineNoticeLabel label="NFC enabled" />
              ) : null}
            </p>
            <div>
              <InjectedSelect
                style={styles.select}
                placeholder={isMembership ? "Start typing member name..." : "Start typing passholder name..."}
                type={isMembership ? "membership_passes" : "passes"}
                labelFormatter={p => `${p.name} (${p.pass_bucket.name})`}
                eventBucketId={eventBucket.id}
                focus={!currentlyCheckinPrintNfcFlow}
                openOnClick={false}
                openOnFocus={false}
                onChange={this.onSelect}
                creatable={true}
                creatablePromptText={n =>
                  `Create new free pass with name "${n}"...`
                }
                onCreateSelect={this.onCreate}
                creatableShowNewOptionAtTop={false}
              />
            </div>
            {selectedPass ? (
              <div style={styles.passInfo}>
                <div style={{ flex: 1 }}>
                  <h2>{selectedPass.name}</h2>
                  <h3>{selectedPass.pass_bucket.name}</h3>
                  <div>
                    Last edited {moment(selectedPass.updated_at).format("lll")}
                  </div>
                  {selectedPass.checked_in_at ? (
                    <div>
                      {`${isMembership ? "Picked up" : "Checked in"} ${moment(selectedPass.checked_in_at).format("lll")}`}
                    </div>
                  ) : (
                    <div>
                      <i>{isMembership ? "Not yet picked up" : "Not yet checked in"}</i>
                    </div>
                  )}
                </div>
                <div style={styles.actions}>
                  {eventBucket.enable_nfc ? (
                    <div>
                      <RaisedButton
                        label={
                          selectedPass.checked_in_at
                            ? "Undo check-in"
                            : "Check in, print & nfc"
                        }
                        primary={!selectedPass.checked_in_at}
                        onClick={() => {
                          if (selectedPass.checked_in_at) {
                            PassActions.edit(selectedPass.id, {
                              checked_in: false
                            });
                          } else {
                            this.onCheckinPrintNfc(selectedPass.id);
                          }
                        }}
                      />
                    </div>
                  ) : (
                    <div>
                      <RaisedButton
                        label={selectedPass.checked_in_at ? "Undo" : isMembership ? "Pick up" : "Check in"}
                        primary={!selectedPass.checked_in_at}
                        style={{ marginRight: 7 }}
                        onClick={() =>
                          PassActions.edit(selectedPass.id, {
                            checked_in: !selectedPass.checked_in_at
                          })
                        }
                      />
                      <RaisedButton
                        label="Print"
                        primary
                        onClick={() =>
                          this.setState({ currentlyPrinting: true })
                        }
                      />
                    </div>
                  )}
                  <div style={{ marginTop: 7 }}>
                    <LinkLike
                      onTouchTap={() =>
                        this.context.router.push(
                          `/event_buckets/${eventBucketId}/passes/${selectedPass.id}`
                        )
                      }
                    >
                      View person
                    </LinkLike>{" "}
                    &middot; 
                    <LinkLike
                      onTouchTap={() =>
                        this.setState({
                          currentlyEditingSupplementaryData: true
                        })
                      }
                    >
                      Edit details
                    </LinkLike>
                  </div>
                  {selectedPass.external_barcode ? (
                    <div style={{ fontSize: "0.8em" }}>
                      NFC identifier: {selectedPass.external_barcode}
                    </div>
                  ) : null}
                </div>
              </div>
            ) : null}
            {Object.values(stats).length > 0 && (
              <div style={styles.stats}>
                <div style={styles.statsHeader}>
                  Current {isMembership ? "pick-ups" : "check-ins"}, by {isMembership ? "membership" : "pass bucket"}
                </div>
                <table className="bordered striped">
                  <tbody>
                    {Object.values(stats)
                      .sort(
                        (a, b) =>
                          b.checked_in - a.checked_in ||
                          a.name.localeCompare(b.name)
                      )
                      .map(s => {
                        return (
                          <tr key={s.name}>
                            <td>{s.name}</td>
                            <td>{`${s.checked_in} / ${s.total}`}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default connectToStores(CheckIn);



// WEBPACK FOOTER //
// ./src/app/components/check-in.jsx